import { useEffect, useState } from 'react';

const TOAST_EVENT = 'app-toast';

export function showToast(message: string) {
  window.dispatchEvent(new CustomEvent(TOAST_EVENT, { detail: message }));
}

export default function ToastHost() {
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    const handler = (event: Event) => {
      const detail = (event as CustomEvent<string>).detail;
      if (detail) {
        setMessage(detail);
      }
    };
    window.addEventListener(TOAST_EVENT, handler);
    return () => window.removeEventListener(TOAST_EVENT, handler);
  }, []);

  useEffect(() => {
    if (!message) {
      return undefined;
    }
    const timer = window.setTimeout(() => setMessage(null), 2200);
    return () => window.clearTimeout(timer);
  }, [message]);

  if (!message) {
    return null;
  }

  return (
    <div className="fixed bottom-8 left-1/2 z-[60] -translate-x-1/2">
      <div className="animate-toast-in flex items-center gap-2 rounded-full border border-background-200 bg-foreground-950 px-5 py-3 text-sm text-background-50">
        <i className="ri-information-line text-base text-accent-400" />
        <span className="whitespace-nowrap">{message}</span>
      </div>
    </div>
  );
}